import * as ActionTypes from '../constants/ActionTypes'
import { postRequest } from './http'

export function loading() {
  return {
    type: ActionTypes.LOADING_CHANGE
  }
}

export function changeFields(fields){
  return {
    type: ActionTypes.SET_FIELDS,
    fields: fields
  }
}

export function errorForm(errors){
  return{
    type: ActionTypes.SET_ERROR_FORMS,
    errors: errors
  }
}

export function setData(items, name) {
  return {
    type: ActionTypes.DATA,
    name: name,
    items: items
  }
}

const changePassword = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    dispatch(errorForm({'errors':{}}));
    postRequest(data, "profile").then(
      (response) => {
        data.current_password = "";
        data.new_password = "";
        data.confirm_new_password = "";
        dispatch(changeFields(data));
        dispatch(setData('Contraseña actualizada', 'toastMessage'));
        dispatch(setData(true, 'simpleToast'));
        setTimeout(function(){
          dispatch(setData(false, 'simpleToast'));
        }, 3000);
        dispatch(loading());
      },
      (err) => {
        dispatch(loading());
        if (err.response.status === 401) {
          dispatch(setData(true, 'error401'));
        }else if(err.response.status === 422){
          dispatch(errorForm(err.response.data));
        }else{
          dispatch(setData(true, 'error'));
        }
      }
    );
  }
};

export default {
  changeFields,
  changePassword
}
